import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { memo, type PropsWithChildren } from 'react';
import { QueryNormalizerProvider } from '@normy/react-query';
import { type NormalizerConfig } from '@normy/core';

type ProviderProps = {
  client: QueryClient;
  normalizerConfig?: Omit<NormalizerConfig, 'structuralSharing'> & {
    normalize?: boolean;
  };
};

export const EpihubQueryProvider = memo(({ client, normalizerConfig, children }: PropsWithChildren<ProviderProps>) => {
  return (
    <QueryNormalizerProvider
      queryClient={client}
      normalizerConfig={normalizerConfig}
    >
      <QueryClientProvider client={client}>
        {children}
      </QueryClientProvider>
    </QueryNormalizerProvider>
  );
});
